export default __webpack_public_path__ + "static/media/tgn_art_platform_01.f1e7935d.png";